// This class initializes the logic for managing user data

class Username {
    constructor(object) {
        this._typeof = 'username'

        if (object) {
            this._businessname = object.businessname
            this._firstname = object.firstname
            this._lastname = object.lastname
            this._middlename = object.middlename
        }
    }

    // getters

    get businessname() {
        return this._businessname
    }

    get firstname() {
        return this._firstname
    }

    get fullname() {
        return this._firstname + ' ' + this._lastname
    }

    get lastname() {
        return this._lastname
    }

    get middlename() {
        return this._middlename
    }

    get typeof() {
        return this._typeof
    }


    // setters

    /**
     * @param {String} newName
     */
    set setBusinessname(newName) {
        this._businessname = newName
    }

    /**
     * @param {String} newName
     */
    set setFirstname(newName) {
        this._firstname = newName
    }

    /**
     * @param {String} newName
     */
    set setLastname(newName) {
        this._lastname = newName
    }

    /**
     * @param {String} newName
     */
    set Middlename(newName) {
        this._middlename = newName
    }
}

export default Username
